// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".page_fIVxD{width:100%}.page__body_MPgAz{padding:16px}.subscriptions_2Aw03{width:100%;display:grid;grid-template-columns:1fr;grid-gap:12px}@media(min-width: 1024px){.subscriptions_2Aw03{grid-template-columns:1fr 1fr}}.subscription_\\+6Yf2{width:100%}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page": "page_fIVxD",
	"page__body": "page__body_MPgAz",
	"subscriptions": "subscriptions_2Aw03",
	"subscription": "subscription_+6Yf2"
};
module.exports = ___CSS_LOADER_EXPORT___;
